import React from 'react';
import { Button, Text, Spacer, Flex, VStack } from '@televet/kibble-ui';
import { ReactComponent as EmptyAutomationsIllustration } from 'pages/Automations/assets/automations-empty-state.svg';
import { useAddNewAutomation } from 'pages/Automations/hooks';

export const AutomationsEmptyState = (): JSX.Element => {
  const { handleAddNewAutomation } = useAddNewAutomation();

  return (
    <Flex
      pos="absolute"
      top="0"
      left="0"
      height="100%"
      width="100%"
      align="center"
      justify="center"
      className="Automations__EmptyState"
      bg="background.default"
      zIndex={2}
    >
      <VStack spacing={2} className="Automations__EmptyState">
        <EmptyAutomationsIllustration />
        <Spacer />
        <Text variant="subtle">No automation selected.</Text>
        <Text variant="subtle">Pick an automation to view from the left, or ...</Text>
        <Spacer />
        <Button
          className="Automations__EmptyState-AddNewButton"
          onClick={handleAddNewAutomation}
          iconName="plus"
          data-mixpanel-name="Add new automation"
          data-testid="add-automation-button"
        >
          Add New Automation
        </Button>
      </VStack>
    </Flex>
  );
};
